export default {
  billing: '费用中心',
  cost_center: '费用中心',
  billing_overview: '总览',
  account_management: '账户资产管理',
  billing_management: '账单管理',
  order_management: '订单管理',
  total_balance: '账户余额',
  recharge: '充值缴费',
  recharge_nav: '充值汇款',
  withdrawal: '余额提现',
  balance: '收支明细',
  cash_amount: '现金金额',
  debt_cash: '欠款金额',
  freeze: '冻结金额',
  last_12_months: '近12个月消费',
  balance_overview: '费用总览',
  month_end_balance: '账户月末余额',
  last_month_end_balance: '上月末余额',
  this_month_end_balance: '本月入账金额',
  month_this_balance: '本月支出金额',
  just_support_bank_transfer: '当前仅支持对公汇款',
  bill_expenses: '账单开销',
  cash_withdrawal: '现金提现及转出',
  freeze_abbreviation: '冻结',
  total_income: '入账金额',
  total_spending: '支出金额',

  order_detail: '订单详情',
  account_money_desc: '账户充值资金在消费之后所剩余的金额',
  fee_Details: '详情',
  post_paid_bill: '账单开销',
  pre_paid_service: '预付费服务支出',
  withdrawal_fee_Details: '现金提现',
  freeze_money: '冻结金额',
  trading_hours: '交易时间',
  serial_id: '流水号',
  trading_money: '交易金额 (¥)',
  income_and_expenditure_types: '收支类型',
  trading_types: '交易类型',
  trading_from: '交易渠道',
  available_amount: '剩余可用金额 (¥)',
  bill_month: '账单月份',
  remark: '备注',
  transaction_type_freeze: '冻结',
  transaction_type_post_paid: '后付费',
  transaction_type_pre_paid: '预付费',
  transaction_type_withdrawal: '提现',
  income: '入账',
  income_channel: '银行汇款',
  express: '支出',
  express_channel: '余额扣款',
  download_details: '下载明细',
  download_all: '下载全部',
  balance_desc_1:
    '收支明细仅显示本账户的充值、提现、退款、扣款等资金增减变化情况，如果需要查看具体资源消耗，可访问',
  balance_desc_bill_details: '账单明细',
  balance_desc_2: '了解详情。',
  balance_desc_3:
    '支持在线查询近18个月详情数据，超过18个月的历史收支明细数据，可下载文件至本地查看，若查询数据量过大，建议拆分时段下载查看。',
  balance_desc_4: '交易数据更新可能有延迟，请耐心等待。',
  not_show_0_cost: '不显示 ￥0 费用',
  current_month: '当月',
  last_month: '上月',
  remittance_name: '汇款户名',
  remittance_bank: '汇款银行',
  remittance_id: '汇款账号',
  remittance_money: '汇款金额 (¥)',
  remittance_time: '汇款到账时间',
  recharge_time: '充值到账时间',
  system_review: '系统审核中',
  system_not_pass: '审核不通过',
  recharging: '充值中',
  already_received: '已到账',
  recharge_record: '对公汇款记录',
  recharge_record_title: '对公汇款记录',
  recharge_record_q: 'Q：汇款页面未查询到充值记录？',
  recharge_record_a:
    ' A：请先联系银行侧确认款项是否转账成功；若转账成功而汇款页面没记录，请根据汇款凭证查看专属账号是否输错/少输；若确认有误请邮件申请原路退回。',
  obtain_reference_id_fail: '获取汇款账号失败',
  not_has_company_auth: '请先完成企业认证，再尝试',
  recharge_account_information: '收款账户信息',
  account: '账户',
  recharge_step: '汇款流程',
  recharge_step_one_title: '确认汇款使用的银行卡户名',
  recharge_step_one_desc_1: '',
  recharge_step_one_desc_2: '实际汇款用户名与下方的汇款人户名一致,',
  recharge_step_one_desc_3: '才可充值到账',
  recharge_step_one_desc_4: '目前仅支持以 ',
  recharge_step_one_desc_5: '企业认证',
  recharge_step_one_desc_6: '为户名汇款，如有其他需求，请联系InGame平台',
  recharge_step_two_title:
    '通过上方显示的汇款户名，将款项汇至InGame专属收款账号',
  recharge_step_two_desc_not_get_1:
    '每个账号会对应分配唯一的银行专属汇款账号，获取后请勿告知他人',
  recharge_step_two_desc_not_get_2:
    '您还未获取专属汇款账号，请点击下方按钮获取',
  recharge_step_two_title_has: '以下是您的InGame专属汇款账号，请勿告知他人',
  recharge_account_name: '收款户名',
  recharge_account_company: '深圳市腾讯计算机系统有限公司',
  recharge_account_bank: '收款银行',
  recharge_account_bank_desc: '招商银行深圳汉京中心支行',
  recharge_account: '收款账户',
  recharge_step_two_btn: '获取专属汇款账号',
  recharge_step_three_title: '等待汇款金额到账',
  recharge_step_three_desc_1:
    '在汇款户名，账号信息均无误的情况下，最快2小时，最长等待1天，请耐心等待',
  recharge_step_three_desc_2:
    '我们将通过邮件、站内信的方式向您反馈充值结果，您也可自行前往',
  recharge_record_desc: '对公汇款记录',
  recharge_step_three_desc_3: '页面查看汇款详情',
  withdrawal_money: '提现金额',
  enter_money: '输入金额',
  withdrawal_money_not_over: '提现金额不可超过当前余额',
  account_received: '到账账户',
  come_back_to_payment_channel: '退回至对应支付渠道',
  withdrawal_apply_commit: '提现申请已提交',
  withdrawal_modal_content:
    '对公汇款提现金额预计 7~15个工作日内 退回到您的银行账户',
  apply_withdrawal_time: '申请提现时间',
  withdrawal_money_and_icon: '提现金额 (¥)',
  withdrawal_account: '提现账户',
  recharge_update_time: '充值到账时间',
  draw_history_type_process: '已申请',
  draw_history_type_process_desc: '预计7~15个工作日内到账',
  draw_history_type_failed: '失败',
  draw_history_type_completed: '成功',
  draw_record: '相关充值记录',
  draw_desc_content_1:
    '提现遵循“后进先出”原则，已消费金额，对应充值记录无法提现。',
  draw_desc_content_2: '【原路提现】充值时间',
  days_range: '在360天内',
  draw_desc_content_3: '的金额，资金可原路退回支付渠道，对公汇款款项预计将',
  days_range_7_15: '在7~15个工作日内',
  draw_desc_content_4: '退回至对应充值账户。',
  draw_desc_content_5: '【线下提现】充值时间',
  days_range_over: '超过360天',
  draw_desc_content_6:
    '的金额，无法通过原充值方式原路提现，可指定账户操作提现。线下提现的款项预计将',
  draw_desc_content_7: '退回至您的账户。',
  can_withdraw_money: '可提现金额',
  withdraw_right_now: '立即提现',
  withdraw_record: '提现记录',
  amount_not_zero: '提现金额不可为0',

  order_post: '后付费订单',
  order_id: '订单号',
  order_fee_mode: '计费模式',
  order_post_fee: '后付费',
  order_game: '所属游戏',
  order_env: '所属环境',
  order_type: '订单类型',
  order_new_pay: '新购',
  order_renew: '续费',
  order_create_time: '订单创建时间',
  order_creator: '订单创建人',
  order_status: '订单状态',
  order_price: '订单金额',
  order_produce: '产品',
  order_sub_id: '子订单号',
  order_freeze_amount: '预估冻结金额',
  order_operate_pay: '支付',
  order_pay_by_quantity: '按量计费',
  order_pay_by_quantity_desc: '适合需求量有大幅波动的业务',
  order_pay_by_quantity_warn: '按量计费模式须知：',
  order_pay_by_quantity_warn_1:
    '1.【先用后付】您可以先使用产品，在结算日（通常为每月1号）将按实际使用情况进行扣费；',
  order_pay_by_quantity_warn_2_1:
    ' 2.【冻结资金】开通按量计费（后付费）资源时，会先',
  order_pay_by_quantity_warn_2_2: '冻结您账户上的部分资金',
  order_pay_by_quantity_warn_2_3: '，余额小于冻结费用则无法开通；',
  order_pay_by_quantity_warn_3:
    '3.【解冻资金】在您主动释放资源或由于您账户欠费导致资源释放后，会解冻该部分资金；',
  order_pay_by_quantity_warn_4:
    '4.【其他】冻结的金额没有实际消耗，在冻结状态下无法使用，解冻后恢复使用。',
  order_pay_by_quantity_tips: '经由人工评估所需费用（即冻结金额）',
  order_status_review: '费用评估中',
  order_status_loading: '待确认',
  order_status_normal: '已完成',
  order_status_cancel: '已取消',
  order_status_review_fail: '审核不通过',
  order_completed: '订单交易完成',
  order_canceled: '订单已取消',
  order_review: '人工评估中',
  order_wait_confirm: '订单待确认',
  order_review_fail: '订单审核不通过',
  order_contact_us: '咨询我们',
  order_pay_failed: '订单支付失败',
  order_modal_confirm_title: '确认服务开通及冻结资金',
  order_modal_confirm_info: '开通本次服务，将冻结账户资金 ',
  order_modal_confirm_content_1:
    '1.开通按量计费（后付费）资源时，会冻结您账户上的部分资金，余额小于冻结费用则无法开通。',
  order_modal_confirm_content_2:
    '2.在您主动释放资源或由于账户欠费导致资源释放后，会解冻该部分资金。',
  order_modal_confirm_content_3:
    '3.冻结金额没有实际消耗，在冻结状态下无法使用，解冻后恢复使用。',
  order_cancel_failed: '取消订单失败',
  order_modal_cancel_title: '取消该订单吗？',
  order_produce_service: '产品服务',
  order_need_amount: '所需冻结金额',
  order_modal_lack_title: '您当前账户资金不足，无法开通服务',
  order_go_to_recharge: '前往充值',
  order_cancel_service: '暂不开通服务',
  order_in_progress: '订单正在处理中，请耐心等待......',
  order_in_progress_desc: '您可以稍后刷新订单状态，或前往订单管理查看。',
  order_done_desc: '您可以前往订单管理查看。',
  order_view_in_management: '查看订单',
  account_balance: '账户资金余额',

  service_shop: '服务选购',
  service_apply_estimate: '申请评估',

  go_to_company_auth: '前往工作室认证',
  not_has_company_auth_desc: '请先完成工作室认证，再访问该界面',
  create_env_no_studio_auth: '尚未完成工作室认证，无法创建该类型环境',
  bill_internal_cert_desc: '内部费用体系建设中，敬请期待',
  bill_intl_site_desc: '国际站费用体系建设中，敬请期待',
  can_not_view_current_page: '无法查看当前页面',
  account_management_info: '账户信息',
  account_management_id: '账户ID',
  account_management_owned_by: '归属工作室',
  account_management_status: '账户状态',
  account_management_status_active: '有效',
  account_management_status_abnormal: '异常（欠费）',
  account_management_status_Unauthenticated: '异常',
  account_management_creation_time: '创建时间',
  account_management_assets: '账户资产',
  account_management_pay: '充值',
  account_management_withdrawal: '提现',
  account_management_details: '明细',
  account_management_admin: '账户管理员',
  account_management_tips:
    '以下账号可以管理本账户。在工作室组织管理中，为账号分配对应功能授权后，可以管理账户上的对应功能。',
  account_management_config: '前往配置',
  account_management_name: '账户名',
  account_management_group: '所在用户组',
  bill_management: '账单管理',
  bill_management_overview: '账单总览',
  bill_management_details: '账单明细',
  bill_management_service: '产品服务',
  bill_management_sub_service: '子产品',
  bill_management_title_env: '所属游戏&环境',
  bill_management_region: '地区',
  bill_management_type: '账单类型',
  bill_management_mode: '计费模式',
  bill_management_time_start: '开始使用时间',
  bill_management_time_end: '结束使用时间',
  bill_management_amount_payable: '应付金额 (¥)',
  bill_management_month_cost: '本月消费',
  bill_management_statistical_cycle: '统计周期',
  bill_management_to: '至',
  bill_management_paid: '已出账',
  bill_management_not_paid: '未出账',

  when_available_balance_less_than_threshold:
    '当可用余额小于阈值时，预警通知会发送到配置的账户邮箱及站内信，每天提醒一次（最多连续5天）',
  warning_threshold: '预警阈值',
  currency_unit: '元',
  notification_scope: '通知范围',
  bill_management_consumption_trend: '消费趋势',
  bill_management_months: '近半年',
  bill_management_year: '近一年',
  bill_management_product_based: '按产品统计',
  bill_management_game_based: '按游戏项目统计',
  bill_management_billing_based: '按计费模式统计',
  bill_management_product_name: '产品名称',
  bill_management_game_project: '游戏项目',
  bill_management_game_name: '游戏名称',
  bill_management_billing_model: '计费模式',
  bill_management_amount: '金额',
  bill_management_proportion: '占比',
  bill_management_annual: '包年包月',
  bill_management_resource: '资源包',
  bill_management_usage: '按量计费',
};
